<template>
<div :style="active ? 'z-index:501' : null">

  <!-- add condition dialog -->
  <v-dialog v-model="active" persistent max-width="500" style="min-height: 350px">
    <v-card>

      <!-- stage 1: location type -->
      <template v-if="stage === 1">
        <v-card-title class="headline">Location Type</v-card-title>
        <v-card-text>What type of area is this?</v-card-text>
        <v-container grid-list-md text-xs-center>
        <v-layout wrap justify-space-around align-center>
          <v-flex xs4 v-for="(item, index) in locationTypes" :key="index">
            <v-avatar :class="{'grey lighten-2': answerLocationType !== item.title, 'primary': answerLocationType === item.title}"
                      size="100px"
                      @click="answerLocationType = item.title">
              <v-icon x-large>{{ item.icon }}</v-icon>
              <!-- <span class="white--text headline">{{ item.substr(0,1) }}</span> -->
            </v-avatar><br>
            {{ item.title }}
          </v-flex>
        </v-layout>
        </v-container>
      </template>

      <!-- stage 1: observation -->
      <template v-if="stage === 2">
      <v-card-title class="headline">Observation</v-card-title>
      <v-card-text>What kind of observation is this?</v-card-text>
      <v-container grid-list-md text-xs-center>
      <v-layout wrap justify-space-around align-center>
        <v-flex xs4 v-for="(item, index) in observations" :key="index">
          <v-avatar 
            :class="{'grey lighten-2': answerObservation !== item.title, 'primary': answerObservation === item.title}"
            size="100px"
            @click="answerObservation = item.title">
            <v-icon x-large>{{ item.icon }}</v-icon>
          </v-avatar><br>
          {{ item.title }}
        </v-flex>
      </v-layout>
      </v-container>
      </template>

      <!-- stage 3: condition -->
      <template v-if="stage === 3">
      <v-card-title class="headline">Add a Condition</v-card-title>
      <v-container grid-list-md text-xs-centerNA>
      <v-layout wrap justify-space-around align-center>
        <v-flex xs12>
          <v-select
            :label="'Select ' + answerObservation + ' type'"
            v-if="answerObservation !== 'Idea'"
            v-model="answerConditionType"
            :items="conditionTypes">
          </v-select>
          <v-text-field
            label="Title"
            v-if="answerConditionType === 'Other'"
            v-model="answerConditionTitle"
            :rules="[(v) => v.length <= 40 || 'Max 40 characters']"
            :counter="40"></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            label="Description"
            v-model="answerConditionDescription"
            :rules="[(v) => v.length <= 100 || 'Max 100 characters']"
            :counter="100"></v-textarea>
        </v-flex>
        <v-flex xs12>
        <label>
          <input
            type="file"
            style="position: fixed; top: -1000px"
            name="condition-photo-file"
            id="condition-photo-file"
            required
            multiple
            @change="getPhotoFiles">
          <v-avatar class="secondary" size="60px">
            <v-icon large color="white">camera_alt</v-icon>
          </v-avatar>
          Please upload a photo of you condition
        </label>
        <div class="pl-2 pt-2 text-xs-left grey--text">Total images selected: {{ totalPhotoFiles }}</div>
        </v-flex>
      </v-layout>
      </v-container>
      </template>

      <!-- stage 4: upload image (if any) -->
      <template v-if="stage === 55">
        <v-card-title class="headline">Upload photo</v-card-title>
        <v-card-text>Upload photos of this location</v-card-text>
        <v-container style="min-height:150px;">
        <v-layout wrap justify-space-around align-center>
          <v-flex xs12>
          <label>
            <input
              type="file"
              style="position: fixed; top: -1000px"
              name="condition-photo-file"
              id="condition-photo-file"
              required
              multiple
              @change="getPhotoFiles">
            <v-avatar class="secondary" size="60px">
              <v-icon large color="white">camera_alt</v-icon>
            </v-avatar>
          </label>
          <span class="pl-2">Total images selected: {{ totalPhotoFiles }}</span>
          </v-flex>
        </v-layout>
        </v-container>
      </template>

      <!-- success or fail upon submission -->
      <transition name="fade">
        <v-container text-xs-center v-if="stage > 3 && httpApiResponseError" pt-3>
          <v-flex xs12>
            <v-avatar class="error" size="100px">
              <v-icon x-large color="white">clear</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex xs12 pt-5 pb-5>
            <h2>Failed to save condition!</h2>
          </v-flex>
        </v-container>
      </transition>
      <transition name="fade">
        <v-container text-xs-center v-if="stage > 3 && httpApiResponseSuccess" pt-3>
          <v-flex xs12>
            <v-avatar class="primary" size="100px">
              <v-icon x-large color="white">check</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex xs12 pt-5 pb-5>
            <h2>Your Condition has been saved!</h2>
          </v-flex>
        </v-container>
      </transition>

      <div style="padding: 70px 80px; text-align: center" v-if="stage > 3 && !httpApiResponseSuccess && !httpApiResponseError">
        <v-progress-linear v-model="httpApiUploadProgress" color="secondary"></v-progress-linear>
        <h2>Saving...</h2>
      </div>

      <transition name="fade">
        <v-alert color="error" icon="warning" value="true"
          v-if="stageIncomplete">
          {{ stageIncompleteMsg }}
        </v-alert>
      </transition>

      <!-- action buttons -->
      <v-card-actions v-if="stage <= 3">
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" flat @click.native="closeDialog">Cancel</v-btn>
        <v-btn color="primary darken-1" flat @click.native="nextStage">Next</v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" flat @click.native="closeDialog">Close</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>

</div>
</template>

<script>

export default {
  name: 'condition-form',
  props: ['saveConditionMethod', 'confirmedLocation'],
  data () {
    return {
      active: false,
      stage: 1,
      answerLocationType: '',
      answerObservation: '',
      answerConditionType:'',
      answerConditionTitle:'',
      answerConditionDescription:'',
      httpApiResponseSuccess: false,
      httpApiResponseError: false,
      httpApiUploadProgress: 0,
      stageIncomplete: false,
      stageIncompleteMsg: '',
      locationTypes: [
        { title: 'Point', icon: 'place' },
        { title: 'Intersection', icon: 'border_inner' },
        { title: 'Corridor', icon: 'nature' }
      ],
      observations: [
        { title: 'Barrier', icon: 'thumb_down' },
        { title: 'Strength', icon: 'thumb_up' },
        { title: 'Idea', icon: 'lightbulb_outline' }
      ],
      conditionTypes: [
        'Art',
        'Bike',
        'Bus Stop',
        'Crosswalks',
        'Landscaping/Shade',
        'Lighting',
        'Maintenance',
        'Other',
        'Safety',
        'Sidewalks',
        'Signage',
        'Street Furniture',
        'Traffic Speed',
      ],
      photoFiles: [],
      photoFile: {},
      photoFileName: ''
    }
  },
  computed: {
    totalPhotoFiles () {
      return this.photoFiles.length
    },
    apiCallsActive () {
      return this.$store.getters.apiCallsInActive
    } 
  },
  watch: {
  },
  methods: {
    getPhotoFile (e) {
      this.photoFile = document.getElementById('condition-photo-file').files[0]
      this.photoFileName = document.getElementById('condition-photo-file').files[0].name
    },
    getPhotoFiles (e) {
      this.photoFiles = []
      let files = document.getElementById('condition-photo-file').files
      if (files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            let file = files[i];
            this.photoFiles.push(file)
          }
      }
    },
    closeDialog () {
      this.active = false;
      this.answerLocationType = ''
      this.answerObservation = ''
      this.answerConditionType = ''
      this.answerConditionTitle = ''
      this.answerConditionDescription = ''
      setTimeout(() => {
        this.stage = 1
      }, 1000)
    },
    nextStage () {
      this.stageIncomplete = false
      if (this.stage === 1 && this.answerLocationType === '') {
        this.stageIncompleteMsg = "Please select a location type!"
        this.stageIncomplete = true
        return
      } else if (this.stage === 2 && this.answerObservation === '') {
        this.stageIncompleteMsg = "Please select an observation!"
        this.stageIncomplete = true
        return
      }
      this.stage++
      if (this.stage > 3) {
        this.saveCondition()
      }
    },
    async saveCondition () {
      let payload = {
        audit_uuid: this.$route.params.auditcode,
        location_type: this.answerLocationType,
        observation: this.answerObservation,
        condition_type: this.answerConditionType,
        title: this.answerConditionTitle,
        description: this.answerConditionDescription,
        lat: this.confirmedLocation.lat,
        lng: this.confirmedLocation.lng
      }
      let imageData = new FormData(); // cannot console log FormData! Use .entries() instead
      imageData.append('audit_uuid', this.$route.params.auditcode)
      this.photoFiles.forEach(file => {
        imageData.append('filename', file, file.name) 
      })
      
      this.httpApiUploadProgress = 0
      this.httpApiResponseSuccess = false
      this.httpApiResponseError = false
      try {
        let responseA = await this.$httpApi.request({ method: 'post', url: '/conditions', data: payload })
        // let responseAdata = responseA.data
        let conditionId = responseA.data.id
        imageData.append('condition_id', conditionId)
        if (this.photoFiles.length){
          // await new Promise(resolve => setTimeout(resolve, 5000))
          this.httpApiUploadProgress = 0
          let responseB = await this.$httpApi.request({
            method: 'post',
            url: '/photos',
            data: imageData,
            headers: { 'Content-Type': 'multipart/form-data' },          
            onUploadProgress: (progressEvent) => {
              this.httpApiUploadProgress = Math.round(100 * progressEvent.loaded/progressEvent.total)
            }      
          })
          responseA.data.photos = responseB.data
        }
        this.httpApiUploadProgress = 100
        this.httpApiResponseSuccess = true
        this.photoFiles = []          
        this.saveConditionMethod(responseA.data)
      } catch (err) {      
        this.httpApiResponseError = false
        return err
      }      

    }
  },

  updated () {
    console.log('condition updated');
  },

  mounted () {
    console.log('condition mounted');
  }

}
</script>


<style class="stylus" scoped>
</style>
